import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        dataLayer: any[];
    }
}

// Use environment variable or fallback to the hardcoded ID
const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID || 'G-CYH913W3QR';

export default function GoogleAnalytics() {
    const location = useLocation();

    useEffect(() => {
        // Only run on client side
        if (typeof window === 'undefined') return;

        // Track page views on route changes
        if (window.gtag) {
            window.gtag('config', GA_TRACKING_ID, {
                page_title: document.title,
                page_location: window.location.href,
                send_page_view: true,
            });
        }
    }, [location]);

    return null;
} 